import { render, staticRenderFns } from "./WorkshopsPayment.vue?vue&type=template&id=49d06f79&scoped=true&"
import script from "./WorkshopsPayment.vue?vue&type=script&lang=js&"
export * from "./WorkshopsPayment.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsPayment.vue?vue&type=style&index=0&id=49d06f79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d06f79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VContainer,VForm,VRow})
